<template>
  <div>
    <ejs-textbox
      :field='field'
      :name='field.name'
      :placeholder='field.placeholder'
      :readonly='field.disabled'
      v-model='value'
      width='80%'>
    </ejs-textbox>
    <div v-show='field.showCheckbox' class='h-mml-chkbox-inlineblock'>
      <ejs-checkbox :checked='checked' v-model='checked' v-show='field.showCheckbox'></ejs-checkbox>
    </div>
  </div>
</template>

<script>

export default {
  name: 'form-input',
  props: {
    field: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      checked: false,
      value: this.field.def
    };
  },
  watch: {
    value(newVal) {
      console.log('value changed---');
      this.$parent.dataCache[this.field.name] = newVal;
      this.field.def = newVal;
    },
    'field.def'(newVal) {
      if (newVal !== this.value) {
        this.value = newVal;
      }
    },
    checked() {
      if (!this.field.showCheckbox) {
        return;
      }
      if (this.checked) {
        this.field.disabled = false;
        this.$parent.addFormItemAndSetFormValidator(this.field.name);
      } else {
        this.field.disabled = true;
        this.$parent.removeFormItemAndSetFormValidator(this.field.name);
      }
    }
  },
  mounted() {
  },
  created() {
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style>

</style>
